import { useContext, useEffect, useState } from "react";
import { FaDownload, FaTrash, FaUpload } from "react-icons/fa";
import FileUploadModal from "./FileUploadModal";
import PaginationComponent from "./PaginationModal";
import { Tooltip } from "@mui/material";
import ConfirmationModal from "./ConfirmationModal";
import SuccessModal from "./SuccessModal";
import {
  GetModuleDocumentCartList,
  DeleteDocument,
  GetModuleDocumentList,
} from "../../services/DocumetUpload/DocumentUploadApi";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import NoResultFoundModel from "./NoDataFound";
import ErrorModal from "./ErrorModal";
const PaperWork = ({ ModuleName, customerKeyID }) => {
  const [errorMessage, setErrorMessage] = useState(false);
  const [isErrorOpen, setIsErrorOpen] = useState(false);
  const [isAddUpdateDone, setIsAddUpdateDone] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [modelAction, setModelAction] = useState("");
  const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [modelRequestData, setModelRequestData] = useState({
    KeyID: null,
    Action: null,
    status: null,
    Name: null,
    remark: null,
  });
  //List Params
  const [DocumentSearch, setDocumentSearch] = useState("");
  const [DocumentList, setDocumentList] = useState([]);
  const [DocumentListCount, setDocumentListCount] = useState(-1);
  const [DocumentCurrentPage, setDocumentCurrentPage] = useState(1);
  //Context
  const { setLoader } = useContext(LoaderContext);
  const { authDetails, pageSize, PanalModuleName, defaultAccess } =
    useContext(AuthContext); //Tab Change Function  //initial UseEffect  //initial UseEffect
  useEffect(() => {
    // Conditionally call the appropriate API based on clientKeyID
    if (customerKeyID) {
      GetModuleDocumentListData(1, null); // Call GetModuleDocumentList if clientKeyID exists
    } else {
      GetModuleDocumentCartListData(1, null); // Call GetModuleDocumentCartList otherwise
    }
  }, [customerKeyID]);

  useEffect(() => {
    if (isAddUpdateDone) {
      setDocumentSearch("");
      if (customerKeyID) {
        GetModuleDocumentListData(1, null); // Call GetModuleDocumentList if clientKeyID exists
      } else {
        GetModuleDocumentCartListData(1, null); // Call GetModuleDocumentCartList otherwise
      }
      setIsAddUpdateDone(false);
    }
  }, [isAddUpdateDone, customerKeyID]);
  //Document Role List Api
  const GetModuleDocumentCartListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetModuleDocumentCartList({
        moduleName: "AddCustomer",
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? DocumentSearch : searchKeyword,
        userKeyID: authDetails.userKeyID,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setDocumentListCount(response.totalCount);
        setDocumentList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const GetModuleDocumentListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetModuleDocumentList({
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? DocumentSearch : searchKeyword,
        fromDate: null,
        toDate: null,
        adminKeyID: authDetails.adminKeyID,
        userKeyID: authDetails.userKeyID,
        moduleName: "Customer",
        clientKeyID: null,
        customerKeyID: customerKeyID,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setDocumentListCount(response.totalCount);
        setDocumentList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const handleDeleteClick = async (file) => {
    setLoader(true);
    try {
      let deleteModuleName;
      let docIdToDelete;

      if (file.mdcid) {
        // GetModuleDocumentList was called and mdcid exists
        deleteModuleName = "Cart";
        docIdToDelete = file.mdcid;
      } else if (file.mdid) {
        // GetModuleDocumentCartList was called and mdid exists
        deleteModuleName = "Main";
        docIdToDelete = file.mdid;
      } else {
        // Neither mdcid nor mdid exists - handle this error case
        setLoader(false);
        setIsErrorOpen(true);
        setErrorMessage("Could not determine document ID for deletion.");
        return;
      }

      const data = await DeleteDocument(deleteModuleName, docIdToDelete);

      if (data?.statusCode === 200) {
        setLoader(false);
        setIsAddUpdateDone(true);
        setShowSuccessPopupModal(true);
      } else {
        setLoader(false);
        setIsErrorOpen(true);
        const errorMessage = data?.response?.data?.errorMessage;
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error deleting document:", error);
      setIsErrorOpen(true);
      setErrorMessage("Failed to delete document.");
    } finally {
      setConfirmationModal(false);
    }
  };

  //Change Page Button
  const HandlePageChange = async (pageNumber) => {
    setDocumentCurrentPage(pageNumber);
    if (customerKeyID) {
      GetModuleDocumentListData(pageNumber); // Call GetModuleDocumentList if clientKeyID exists
    } else {
      GetModuleDocumentCartListData(pageNumber); // Call GetModuleDocumentCartList otherwise
    } // Call your function with the selected page number
  };

  // Function to handle direct file download
  const handleDownloadFile = (docPath, docName) => {
    // Create an invisible <a> element
    const link = document.createElement("a");
    link.href = docPath;

    // Extract filename with extension to set in download attribute
    let fileName = docName || "downloaded_file"; // Fallback to a generic name if docName is not provided
    link.download = fileName;

    // Append to the body, trigger click, and remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="h-full bg-white shadow rounded-lg flex flex-col">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "4px 15px",
        }}
        className="border-b p-4 overflow-x-auto"
      >
        {ModuleName !== "ViewClient" && (
          <div className="flex space-x-4">
            <button
              className={`px-4 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0] text-12`}
            >
              Paper Work
            </button>
          </div>
        )}
      </div>
      <div className="p-2 border-b flex flex-wrap sm:flex-nowrap items-center justify-between gap-3">
        {/* Left Side: Select Dropdown */}
        <div className="w-full sm:w-60"></div>

        {/* Right Side: Search Bar & Add Button */}
        <div className="flex flex-wrap sm:flex-nowrap items-center w-full sm:w-auto gap-3">
          {/* Search Bar */}
          <div className="relative flex items-center w-full sm:w-64">
            <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
            <input
              type="text"
              className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
              placeholder="Search Document"
            />
          </div>

          {/* Add Button */}
          <Tooltip title="Add Document">
            <button
              id="addBtn"
              type="button"
              onClick={() => setShowUploadModal(true)}
              className="flex items-center gap-2 text-white bg-[#E86B1B] rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
            >
              <FaUpload size={14} /> {/* You can adjust size here */}
              Upload
            </button>
          </Tooltip>
        </div>
      </div>

      {/* File List Table */}
      <div className="flex flex-col table_wrapper border border-gray-200">
        <div className="flex-1 overflow-y-auto">
          <table className="w-full border border-gray-300 rounded-md">
            <thead>
              <tr className="z-1 sticky top-0 bg-white">
                <th className="text-12  border-b border-slate-200 bg-slate-50 text-center whitespace-nowrap p-1">
                  Document Name
                </th>
                <th className="text-12  border-b border-slate-200 bg-slate-50 text-center whitespace-nowrap p-1">
                  Document Type
                </th>
                <th className="text-12  border-b border-slate-200 bg-slate-50 text-center whitespace-nowrap p-1">
                  Document Size
                </th>
                <th className="text-12  border-b border-slate-200 bg-slate-50 text-center whitespace-nowrap p-1">
                  Upload Date
                </th>

                <th className="text-12  border-b border-slate-200 bg-slate-50 text-center whitespace-nowrap p-1">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {DocumentList.map((file) => (
                <tr key={file.id} className="border-t">
                  <td className="p-1 text-12 ">{file.docName}</td>
                  <td className="p-1 text-12 ">{file.documentType}</td>
                  <td className="p-1 text-12 ">{file.docSizeInKB}</td>
                  <td className="p-1 text-12 ">{file.createdOnDate}</td>
                  <td className="p-1 border-b border-gray-400 text-12">
                    <div className="flex justify-center gap-2">
                      <Tooltip title="Download">
                        <button
                          className="text-[#135EA0] hover:text-[#0E4C84] transition"
                          onClick={() => {
                            handleDownloadFile(file.docPath, file.docName);
                          }}
                        >
                          <FaDownload className="text-[12px]" />
                        </button>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <button
                          className="text-gray-400 hover:text-gray-500 transition"
                          onClick={() => {
                            handleDeleteClick(file);
                          }}
                        >
                          <FaTrash className="text-12" />
                        </button>
                      </Tooltip>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {DocumentListCount <= 0 && (
            <NoResultFoundModel totalRecords={DocumentListCount} />
          )}
        </div>
      </div>
      {DocumentListCount > pageSize && (
        <div className="flex justify-end ">
          <PaginationComponent
            totalPages={Math.ceil(DocumentListCount / pageSize)}
            currentPage={DocumentCurrentPage}
            onPageChange={HandlePageChange}
          />
        </div>
      )}
      <FileUploadModal
        ModuleName={ModuleName}
        show={showUploadModal}
        setIsAddUpdateDone={setIsAddUpdateDone}
        onClose={() => setShowUploadModal(false)}
        customerKeyID={customerKeyID} // Pass customerKeyID here
      />

      <SuccessModal
        isOpen={showSuccessPopupModal}
        onClose={() => setShowSuccessPopupModal(false)}
        modelAction={modelAction}
        actionMessage={modelRequestData.Name}
      />
      <ErrorModal
        isOpen={isErrorOpen}
        onClose={() => setIsErrorOpen(false)}
        errorMessage={errorMessage}
      />
    </div>
  );
};

export default PaperWork;
